
    import '/opt/buildhome/repo/packages/x/components/folder/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["folder-demo-basic","folder-demo-custom-service","folder-demo-file-controlled","folder-demo-fully-controlled","folder-demo-searchable","folder-demo-custom-icons","folder-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/folder/index.en-US.md?type=demo')
};